import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { Textfield } from "../..";
import { SignInData } from "../../ui-dto/sign/sign-in-data";
import { SignInActionData } from "../../ui-dto/sign/sign-in-action-data";
import { SignInModeData } from "../../ui-dto/sign/sign-in-mode-data";
var HTML_TEMPLATE = "\n<od-box-container>\n  <div class=\"od-sign-in-content\" header></div>\n  <form id=\"signInForm\" class=\"od-sign-in-content\" body  autoComplete=\"on\" (submit)=\"handleSignIn()\">\n    <label class=\"od-sign-in-signIn\">\n      {{'SignIn.signInToYourAccount'| translate:{organizationName:organizationName} }}\n    </label>\n    \n    <od-textfield *ngIf=\"_mode === SignInModeData.EMAIL\" #emailTF type=\"email\" required=\"true\"\n      iconName=\"odi_email\" class=\"od-sign-in-textfield\" autocomplete=\"username\"\n                  [placeholder]=\"'SignIn.email' | translate\"></od-textfield>\n                  \n    <od-textfield *ngIf=\"_mode === SignInModeData.PASSWORD\" #passwordTF type=\"password\" required=\"true\"\n     iconName=\"odi_lock\" class=\"od-sign-in-textfield od-sign-in-textfield-password\" autocomplete=\"current-password\"\n                  [placeholder]=\"'SignIn.password' | translate\"></od-textfield>\n                  \n    <od-icon-link [clickable]=\"true\" class=\"od-sign-in-reset-password\"  (click)=\"onResetPassword()\"\n                  [text]=\"'SignIn.resetPassword' | translate\"\n                  *ngIf=\"_mode === SignInModeData.EMAIL\"></od-icon-link>\n                  \n    <od-code-field *ngIf=\"_mode === SignInModeData.CODE\" (onSubmit)=\"_handleCode($event)\" ></od-code-field>\n                  \n    <div tabIndex=\"-1\" *ngIf=\"_mode === SignInModeData.PASSWORD && !_twoFactorAuthEnabled\" class=\"od-sign-in-button-switch\" \n    (click)=\"_handleSwitchMode(SignInModeData.CODE)\">\n      Sign in with Code\n    </div>\n    \n    <div tabIndex=\"-1\"  *ngIf=\"_mode === SignInModeData.CODE && !_twoFactorAuthEnabled\" class=\"od-sign-in-button-switch\"\n    (click)=\"_handleSwitchMode(SignInModeData.PASSWORD)\">\n      Sign in with Password\n    </div>\n               \n    <od-button *ngIf=\"action === SignInActionData.NEXT\" iconName=\"odi_signIn\" size=\"inherit\" class=\"od-sign-in-button-sign-in\" [type]=\"submit\"\n               [text]=\"'SignIn.next' | translate\" [color]=\"buttonTextColor\" [bgColor]=\"buttonColor\"></od-button>\n               \n    <od-button *ngIf=\"action === SignInActionData.SIGN_IN\" iconName=\"odi_signIn\" size=\"inherit\" class=\"od-sign-in-button-sign-in\"  [type]=\"submit\"\n               [text]=\"'SignIn.signIn' | translate\" [color]=\"buttonTextColor\" [bgColor]=\"buttonColor\"></od-button>\n  </form>\n  <div class=\"od-sign-in-content\" footer *ngIf=\"canSignUp && _mode === SignInModeData.EMAIL\">\n    <div  class=\"od-sign-in-have-account\">\n      {{'SignIn.haveYouAccount'| translate:{organizationName:organizationName} }}\n    </div>\n    <od-icon-link [text]=\"'SignIn.signUp' | translate\" [clickable]=\"true\" (click)=\"onSignUp()\"\n                  class=\"od-sign-in-sign-up\"></od-icon-link>\n  </div>\n  <div class=\"od-sign-in-content\" footer *ngIf=\"_mode === SignInModeData.CODE\">\n    <od-icon-link [text]=\"'SignIn.signInInfo' | translate\" [clickable]=\"true\" (click)=\"onSignInInfo(true)\"\n                  class=\"od-sign-in-sign-in-info\"></od-icon-link>\n    <od-sign-in-info *ngIf=\"_showSignInInfo === true\" (onClose)=\"onSignInInfo(false)\"></od-sign-in-info>\n  </div>\n</od-box-container>\n{{_handleForm()}}\n";
var CSS_STYLE = "\n.od-sign-in-content[header] {\n  padding: 20px;\n}\n\n.od-sign-in-content[body] {\n  width: 100%;\n  border-radius: 4px;\n  border: solid 1px #dfe3e9;\n  margin-bottom: 40px;\n  box-sizing: border-box;\n  display: flex;\n  background-color: white;\n  padding: 40px;\n  flex-direction: column;\n  align-items: center;\n}\n\n.od-sign-in-content[body] .od-sign-in-signIn {\n  font-size: 20px;\n  margin-bottom: 28px;\n  width: 100%;\n  text-align: center;\n}\n\n.od-sign-in-content[body] .od-sign-in-textfield,\n.od-sign-in-content[body] .od-sign-in-button-sign-in {\n  margin-top: 12px;\n  margin-bottom: 8px;\n  width: 100%;\n}\n\n.od-sign-in-content[body] .od-sign-in-reset-password {\n  margin-bottom: 16px;\n  font-size: 12px;\n  font-weight: bold;\n  align-self: flex-end;\n}\n\n.od-sign-in-content[footer]  {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 8px;\n}\n\n.od-sign-in-content[footer] .od-sign-in-have-account {\n  align-self: center;\n  margin-bottom: 1px;\n  margin-right: 4px;\n}\n\n.od-sign-in-button-switch{\n  padding: 10px 10px 8px;\n  border-radius: 5px;\n  margin: 6px;\n  color: #0f6b8a;\n  font-weight: normal;\n}\n\n.od-sign-in-button-switch:hover {\n  background-color: #d2edf9;\n}\n.od-sign-in-textfield.od-sign-in-textfield-password{\n  padding:10px 0;\n}\n";
var SignIn = /** @class */ (function () {
    function SignIn() {
        this.canSignUp = false;
        this.canResetPassword = false;
        this.odSignIn = new EventEmitter();
        this.odResetPassword = new EventEmitter();
        this.odSignUp = new EventEmitter();
        this.onModeChanged = new EventEmitter();
        this.onTwoFactorAuthEnabled = new EventEmitter();
        this.SignInActionData = SignInActionData;
        this.SignInModeData = SignInModeData;
        this._code = undefined;
        this._defaultMode = SignInModeData.CODE;
        this._twoFactorAuthEnabled = undefined;
        this._email = "";
        this._password = undefined;
        this._mode = undefined;
        this.organizationName = "";
        this.action = SignInActionData.NEXT;
        if (this.buttonColor == null)
            this.buttonColor = "#25aed8";
        if (this.buttonTextColor == null)
            this.buttonTextColor = "#FFFFFF";
        this._mode = SignInModeData.EMAIL;
        this._showSignInInfo = false;
    }
    SignIn.prototype.clear = function () {
        this.emailTF.clear();
        this.passwordTF.clear();
    };
    SignIn.prototype.onResetPassword = function () {
        this.odResetPassword.emit();
    };
    SignIn.prototype.onSignUp = function () {
        this.odSignUp.emit();
    };
    SignIn.prototype.onSignInInfo = function (value) {
        this._showSignInInfo = value;
    };
    SignIn.prototype.handleSignIn = function (e) {
        if (e != null) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (this.emailTF != null) {
            this._email = this.emailTF.value;
        }
        if (this.passwordTF != null) {
            this._password = this.passwordTF.value;
        }
        if (this._email == null) {
            this.action = SignInActionData.NEXT;
            this._code = undefined;
            this._password = undefined;
            this.passwordTF.value = "";
            this._twoFactorAuthEnabled = undefined;
            this._mode = SignInModeData.EMAIL;
            this.onModeChanged.emit(SignInModeData.EMAIL);
        }
        else if (this._twoFactorAuthEnabled == null) {
            this.onTwoFactorAuthEnabled.emit(this._email);
        }
        else {
            this._handleSignInNext();
        }
    };
    Object.defineProperty(SignIn.prototype, "isTwoFactorAuthEnabled", {
        set: function (value) {
            if (value != null && this._email != null && this._email !== "" && this._twoFactorAuthEnabled == null) {
                this._defaultMode = value.defaultMode;
                this._twoFactorAuthEnabled = value.twoFactorAuthEnabled;
                this._handleSignInNext();
            }
        },
        enumerable: true,
        configurable: true
    });
    SignIn.prototype._handleSwitchMode = function (mode) {
        this._mode = mode;
    };
    SignIn.prototype._handleForm = function () {
        var element = document.getElementById("signInForm");
        if (element != null) {
            element.removeAttribute("novalidate");
        }
    };
    SignIn.prototype._handleCode = function (value) {
        this._code = value;
        this._handleSignInNext();
    };
    SignIn.prototype._handleSignInNext = function () {
        if (this.odSignIn != null) {
            if (this._twoFactorAuthEnabled) {
                if (this._password == null) {
                    this.action = SignInActionData.NEXT;
                    this._code = undefined;
                    this._mode = SignInModeData.PASSWORD;
                    this.onModeChanged.emit(SignInModeData.PASSWORD);
                }
                else if (this._code == null) {
                    this.odSignIn.emit(new SignInData(this._email, this._password, undefined, undefined));
                    this.action = SignInActionData.SIGN_IN;
                    this._mode = SignInModeData.CODE;
                    this.onModeChanged.emit(SignInModeData.CODE);
                }
                else {
                    this.odSignIn.emit(new SignInData(this._email, this._password, false, this._code, undefined));
                }
            }
            else {
                if (this._mode === SignInModeData.EMAIL) {
                    this.action = SignInActionData.SIGN_IN;
                    this._mode = this._defaultMode;
                    this.onModeChanged.emit(this._defaultMode);
                }
                else if ((this._mode === SignInModeData.CODE && this._code != null) ||
                    (this._mode === SignInModeData.PASSWORD && this._password != null)) {
                    this.odSignIn.emit(new SignInData(this._email, this._password, false, this._code, this._mode === SignInModeData.CODE));
                }
            }
        }
    };
    SignIn.decorators = [
        { type: Component, args: [{
                    selector: "od-sign-in",
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    SignIn.ctorParameters = function () { return []; };
    SignIn.propDecorators = {
        "organizationName": [{ type: Input },],
        "buttonTextColor": [{ type: Input },],
        "buttonColor": [{ type: Input },],
        "canSignUp": [{ type: Input },],
        "canResetPassword": [{ type: Input },],
        "emailTF": [{ type: ViewChild, args: ["emailTF",] },],
        "passwordTF": [{ type: ViewChild, args: ["passwordTF",] },],
        "odSignIn": [{ type: Output },],
        "odResetPassword": [{ type: Output },],
        "odSignUp": [{ type: Output },],
        "onModeChanged": [{ type: Output },],
        "onTwoFactorAuthEnabled": [{ type: Output },],
        "action": [{ type: Input },],
        "isTwoFactorAuthEnabled": [{ type: Input },],
    };
    return SignIn;
}());
export { SignIn };
//# sourceMappingURL=sign-in.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui/sign/sign-in.js
// module id = 439
// module chunks = 14